import { optionSubcategory_mailboxCleanup } from './storageSubCategory.locstring.json';
import { StorageOption } from 'owa-storage-option';
import { OptionSubCategory } from 'owa-options-core';
import { loadStorageInformation } from '../util/loadStorageInformation';

let storageSubcategory: OptionSubCategory = {
    key: 'storage',
    titleStringKey: optionSubcategory_mailboxCleanup,
    options: [StorageOption],
    onSelected: () => {
        return loadStorageInformation();
    },
    refreshOnSelected: true,
};

export default storageSubcategory;
